import { EmojiPickerViewState } from '../store/schema/EmojiPickerViewState';
import getViewAllIndex from '../utils/getViewAllIndex';
import { mutatorAction } from 'satcheljs';

// Updates current index by the increment amount
export default mutatorAction(
    'updateEmojiSelectedIndex',
    (viewState: EmojiPickerViewState, increment: 1 | -1) => {
        // The amount of selectable slots is the same as the index of the "..." button plus 1
        const emojiPickerSlots = getViewAllIndex(viewState.emojiResults) + 1;
        const updatedEmojiIndex =
            (viewState.selectedEmojiIndex + emojiPickerSlots + increment) % emojiPickerSlots;
        viewState.selectedEmojiIndex = updatedEmojiIndex;
    }
);
